import type { ProductLogoMediumProps } from "../types";

export function ProductLogoMediumBusinessPartner({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M428 121C421.373 121 416 126.373 416 133V217H368C361.373 217 356 222.373 356 229V421C356 427.627 361.373 433 368 433H548C554.627 433 560 427.627 560 421V181C560 174.373 554.627 169 548 169H500V133C500 126.373 494.627 121 488 121H428Z"
        fill="#57D7D9"
      />
      <path
        d="M536 249C536 244.582 532.418 241 528 241H508C503.582 241 500 244.582 500 249V257C500 261.418 503.582 265 508 265H528C532.418 265 536 261.418 536 257V249Z"
        fill="#1A2142"
      />
      <path
        d="M536 201C536 196.582 532.418 193 528 193H508C503.582 193 500 196.582 500 201V209C500 213.418 503.582 217 508 217H528C532.418 217 536 213.418 536 209V201Z"
        fill="#1A2142"
      />
      <path
        d="M476 153C476 148.582 472.418 145 468 145H448C443.582 145 440 148.582 440 153V161C440 165.418 443.582 169 448 169H468C472.418 169 476 165.418 476 161V153Z"
        fill="#1A2142"
      />
      <path
        d="M536 297C536 292.582 532.418 289 528 289H508C503.582 289 500 292.582 500 297V305C500 309.418 503.582 313 508 313H528C532.418 313 536 309.418 536 305V297Z"
        fill="#1A2142"
      />
      <path
        d="M536 345C536 340.582 532.418 337 528 337H508C503.582 337 500 340.582 500 345V353C500 357.418 503.582 361 508 361H528C532.418 361 536 357.418 536 353V345Z"
        fill="#1A2142"
      />
      <path
        d="M476 201C476 196.582 472.418 193 468 193H448C443.582 193 440 196.582 440 201V209C440 213.418 443.582 217 448 217H468C472.418 217 476 213.418 476 209V201Z"
        fill="#1A2142"
      />
      <path
        d="M476 249C476 244.582 472.418 241 468 241H448C443.582 241 440 244.582 440 249V257C440 261.418 443.582 265 448 265H468C472.418 265 476 261.418 476 257V249Z"
        fill="#1A2142"
      />
      <path
        d="M476 297C476 292.582 472.418 289 468 289H448C443.582 289 440 292.582 440 297V305C440 309.418 443.582 313 448 313H468C472.418 313 476 309.418 476 305V297Z"
        fill="#1A2142"
      />
      <path
        d="M416 297C416 292.582 412.418 289 408 289H388C383.582 289 380 292.582 380 297V305C380 309.418 383.582 313 388 313H408C412.418 313 416 309.418 416 305V297Z"
        fill="#1A2142"
      />
      <path
        d="M416 249C416 244.582 412.418 241 408 241H388C383.582 241 380 244.582 380 249V257C380 261.418 383.582 265 388 265H408C412.418 265 416 261.418 416 257V249Z"
        fill="#1A2142"
      />
      <path
        d="M476 345C476 340.582 472.418 337 468 337H448C443.582 337 440 340.582 440 345V353C440 357.418 443.582 361 448 361H468C472.418 361 476 357.418 476 353V345Z"
        fill="#1A2142"
      />
      <path
        d="M416 345C416 340.582 412.418 337 408 337H388C383.582 337 380 340.582 380 345V353C380 357.418 383.582 361 388 361H408C412.418 361 416 357.418 416 353V345Z"
        fill="#1A2142"
      />
      <path
        d="M488 393C488 388.582 484.418 385 480 385H436C431.582 385 428 388.582 428 393V433H488V393Z"
        fill="#1A2142"
      />
      <path
        d="M110 478C110 424.981 152.981 382 206 382H326C379.019 382 422 424.981 422 478V514C422 520.627 416.627 526 410 526H122C115.373 526 110 520.627 110 514V478Z"
        fill="white"
      />
      <path
        d="M110.004 514.31C110.168 520.794 115.476 526 122 526H410L410.31 525.996C416.794 525.832 422 520.524 422 514V478C422 424.981 379.019 382 326 382V358C392.274 358 446 411.726 446 478V514C446 533.882 429.882 550 410 550H122C102.118 550 86 533.882 86 514V478C86 411.726 139.726 358 206 358V382C152.981 382 110 424.981 110 478V514L110.004 514.31ZM326 358V382H206V358H326Z"
        fill="#1A2142"
      />
      <path
        d="M350 274C350 320.392 312.392 358 266 358C219.608 358 182 320.392 182 274C182 227.608 219.608 190 266 190C312.392 190 350 227.608 350 274Z"
        fill="white"
      />
      <path
        d="M350 274C350 227.608 312.392 190 266 190C219.608 190 182 227.608 182 274C182 320.392 219.608 358 266 358C312.392 358 350 320.392 350 274ZM374 274C374 333.647 325.647 382 266 382C206.353 382 158 333.647 158 274C158 214.353 206.353 166 266 166C325.647 166 374 214.353 374 274Z"
        fill="#1A2142"
      />
      <path
        d="M254 452C254 445.373 259.373 440 266 440C272.627 440 278 445.373 278 452V520C278 526.627 272.627 532 266 532C259.373 532 254 526.627 254 520V452Z"
        fill="#57D7D9"
      />
      <path
        d="M254 520C254 526.627 259.373 532 266 532C272.524 532 277.832 526.794 277.996 520.31L278 520V452C278 445.373 272.627 440 266 440C259.373 440 254 445.373 254 452V520ZM302 520C302 539.882 285.882 556 266 556C246.118 556 230 539.882 230 520V452C230 432.118 246.118 416 266 416C285.882 416 302 432.118 302 452V520Z"
        fill="#1A2142"
      />
      <path
        d="M250 400C250 391.163 257.163 384 266 384C274.837 384 282 391.163 282 400C282 408.837 274.837 416 266 416C257.163 416 250 408.837 250 400Z"
        fill="#57D7D9"
      />
      <path
        d="M282 400C282 391.163 274.837 384 266 384C257.163 384 250 391.163 250 400C250 408.837 257.163 416 266 416C274.837 416 282 408.837 282 400ZM306 400C306 422.091 288.091 440 266 440C243.909 440 226 422.091 226 400C226 377.909 243.909 360 266 360C288.091 360 306 377.909 306 400Z"
        fill="#1A2142"
      />
    </svg>
  );
}
